var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from "react-router-dom";
import { ContextMenuAFY, icons, sizesIcon, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React from "react";
import { SpanStatus } from "./style";
export var ColumnsPaymentRecurrence = function (clickContextMenuRecurrence) {
    var idProduct = useParams().idProduct;
    var isEdit = useParams().isEdit;
    return [
        {
            field: "actions",
            headerName: "",
            width: 80,
            renderCell: function (params) { return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: (!idProduct || (idProduct && isEdit === "true")) && (_jsx(ContextMenuAFY, { colorButton: "#fff", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: [
                        {
                            disabled: false,
                            icon: {
                                color: "#006ac6",
                                icon: icons.DeleteForever,
                                size: sizesIcon.standard,
                            },
                            id: "1",
                            name: "Eliminar",
                        },
                    ], onClickContextMenu: function () { return clickContextMenuRecurrence(params === null || params === void 0 ? void 0 : params.row); }, sizeIcon: sizesIcon.standard })) }))); },
        },
        {
            editable: false,
            field: "code",
            flex: 1,
            headerName: "Código",
            width: 150,
        },
        {
            editable: false,
            field: "description",
            flex: 1,
            headerName: "Descripción",
            width: 160,
        },
    ];
};
export var ColumnsPaymentMode = function (clickContextMenuPaymentMode) {
    var idProduct = useParams().idProduct;
    var isEdit = useParams().isEdit;
    return [
        {
            field: "actions",
            headerName: "",
            width: 80,
            renderCell: function (params) { return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: (!idProduct || (idProduct && isEdit === "true")) && (_jsx(ContextMenuAFY, { colorButton: "#fff", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: [
                        {
                            disabled: false,
                            icon: {
                                color: "#006ac6",
                                icon: icons.DeleteForever,
                                size: sizesIcon.standard,
                            },
                            id: "1",
                            name: "Eliminar",
                        },
                    ], onClickContextMenu: function () {
                        return clickContextMenuPaymentMode(params === null || params === void 0 ? void 0 : params.row);
                    }, sizeIcon: sizesIcon.standard })) }))); },
        },
        {
            editable: false,
            field: "code",
            flex: 1,
            headerName: "Código",
            width: 150,
        },
        {
            editable: false,
            field: "description",
            flex: 1,
            headerName: "Descripción",
            width: 160,
        },
    ];
};
export var ColumnsPlans = function (clickContextMenuPlans) {
    var idProduct = useParams().idProduct;
    var isEdit = useParams().isEdit;
    return [
        {
            field: "actions",
            headerName: "",
            width: 80,
            renderCell: function (params) { return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: (!idProduct || (idProduct && isEdit === "true")) && (_jsx(ContextMenuAFY, { colorButton: "#fff", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: [
                        {
                            disabled: false,
                            icon: {
                                color: "#006ac6",
                                icon: icons.Visibility,
                                size: sizesIcon.standard,
                            },
                            id: "1",
                            name: "Ver plan",
                        },
                    ], onClickContextMenu: function () { return clickContextMenuPlans(params === null || params === void 0 ? void 0 : params.row); }, sizeIcon: sizesIcon.standard })) }))); },
        },
        {
            field: "code",
            headerName: "Código",
            width: 180,
        },
        {
            field: "name",
            headerName: "Nombre",
            width: 180,
            flex: 1,
        },
        {
            field: "coverType",
            headerName: "Tipo de cobertura",
            width: 230,
            flex: 1,
        },
    ];
};
export var ColumnsActionsFlags = function () {
    var idProduct = useParams().idProduct;
    var isEdit = useParams().isEdit;
    return [
        {
            field: "actions",
            headerName: "",
            width: 80,
            renderCell: function (params) {
                return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: (!idProduct || (idProduct && isEdit === "true")) && (_jsx(ContextMenuAFY, { colorButton: "#fff", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: [
                            params.row.value === "Activo"
                                ? {
                                    disabled: false,
                                    icon: {
                                        color: "#ef2f24",
                                        icon: icons.Unpublished,
                                        size: sizesIcon.standard,
                                    },
                                    id: "1",
                                    name: "Desactivar",
                                }
                                : {
                                    disabled: false,
                                    icon: {
                                        color: "#46c51a",
                                        icon: icons.CheckCircle,
                                        size: sizesIcon.standard,
                                    },
                                    id: "2",
                                    name: "Activar",
                                },
                        ], 
                        // onClickContextMenu={(item: any) =>
                        //   // handleClickContextMenu(item, params)
                        // }
                        sizeIcon: sizesIcon.standard })) })));
            },
        },
        {
            editable: false,
            field: "value",
            headerName: "Estado",
            width: 180,
            renderCell: function (params) {
                return (_jsxs("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: [_jsx(SpanStatus, { style: {
                                backgroundColor: params.row.value === "Activo" ? "#46c51a" : "#ef2f24",
                            } }), params.value] })));
            },
        },
        {
            editable: false,
            field: "name",
            headerName: "Nombre",
            width: 180,
            flex: 1,
        },
    ];
};
export var dataProductCreationForm = {
    IdSponsor: "",
    IdTypeInsurance: "",
    Description: "",
    Code: "",
    IdCurrency: "",
    CertifyNumber: "",
    QuotesNumber: 0,
    PolicyNumber: 0,
};
export var dataForm = {
    CampaignName: "",
    CodeCampaign: "",
    StartDateCampaign: "",
    EndDateCampaign: "",
};
